import { Injectable } from '@angular/core';

import {apiName, locaisCombustiveisApiName} from "./data.service";
import { RestService } from "../../../core/services/rest.service";
import {Local, LocalCombustivel} from "./local.model";

@Injectable()
export class LocalApiService {

    constructor(
        private _restService: RestService
    ) { }

    //local
    onPost(object: Local, done: any) {
        this._restService.onPost(apiName, object, done);
    }

    onPut(object: Local, done: any) {
        this._restService.onPut(apiName, object, done);
    }

    onDelete(objectId: number, done: any) {
        this._restService.onDelete(apiName, objectId, done);
    }

    onGetAll(done: any) {
        let filter: any = {"order":"nome"};
        this._restService.onGetPost(apiName, filter, done);
    }

    onGetById(objectId: number, done: any) {
        let filter: any = {"include":["endereco"]};
        this._restService.onGetPostId(apiName, objectId, filter, done);
    }

    onGetApiUrl() {
        return apiName;
    }

    //local-combustivel
    onPostLocalCombustivel(object: LocalCombustivel, done: any) {
        this._restService.onPost(locaisCombustiveisApiName, object, done);
    }

    onPutLocalCombustivel(object: LocalCombustivel, done: any) {
        this._restService.onPut(locaisCombustiveisApiName, object, done);
    }

    onDeleteLocalCombustivel(objectId: number, done: any) {
        this._restService.onDelete(locaisCombustiveisApiName, objectId, done);
    }

    onGetAllLocalCombustivel(done: any) {
        let filter: any = {"include":["combustivel"]};
        this._restService.onGetPost(locaisCombustiveisApiName, filter, done);
    }

    onGetLocalCombustivelByLocal(localId: number, done: any) {
        let filter: any = {"include":["combustivel"],"where":{"localId":localId}};
        this._restService.onGetPost(locaisCombustiveisApiName, filter, done);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/locais/shared/local-api.service.ts
 **/